// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__31GD6","addWidgetButton":"Header_addWidgetButton__1QYSk","dashboardTabs":"Header_dashboardTabs__2DZhh","active":"Header_active__3ZICX"};